import { FloatingPortal } from '@floating-ui/react'
import { forwardRef, useMemo } from 'react'
import { mergeRefs } from 'react-merge-refs'

import { cn } from '@sparkai/utils'

import { TooltipState } from './useTooltipState'

export type TooltipContentProps = React.HTMLProps<HTMLDivElement> & {
  state: TooltipState
  theme: 'light' | 'dark'
}

export const TooltipContent = forwardRef<HTMLDivElement, TooltipContentProps>(function TooltipContent(
  { state, theme, ...props },
  propRef
) {
  const ref = useMemo(() => mergeRefs([state.floating, propRef]), [state.floating, propRef])

  return (
    <FloatingPortal>
      {state.open && (
        <div
          ref={ref}
          style={{
            position: state.strategy,
            top: state.y ?? 0,
            left: state.x ?? 0,
            visibility: state.x == null ? 'hidden' : 'visible',
            zIndex: 99999,
            ...props.style,
          }}
          {...state.getFloatingProps(props)}
          className={cn(
            'max-w-sm rounded-md px-3 py-2 text-xs leading-4 font-medium shadow-md',
            {
              'bg-white text-gray-700': theme === 'light',
              'bg-gray-operator text-white': theme === 'dark',
            },
            props.className
          )}
        />
      )}
    </FloatingPortal>
  )
})
